import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7e0bd5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[15px]"
}
const _hoisted_2 = {
  key: 1,
  class: "custom-global-skeleton tw-w-full tw-h-[15px]"
}
const _hoisted_3 = { class: "tw-flex tw-items-center tw-justify-center tw-gap-[6px]" }
const _hoisted_4 = {
  key: 1,
  class: "text"
}

import store from "@/store";
import { computed, PropType } from "vue";
import { TYPE_SCHEDULE } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'issuesNumberDots',
  props: {
  className: {
    type: String,
    required: false,
    default: "",
  },
  severity: {
    type: Object as PropType<
      Record<"critical" | "high" | "medium" | "low", number | string>
    >,
    required: false,
    default: () => ({
      critical: 0,
      high: 0,
      medium: 0,
      low: 0,
    }),
  },
  currentRefreshId: {
    type: [Number, String],
    required: false,
    default: 0,
  },
  scanTargetType: {
    type: String as PropType<keyof typeof TYPE_SCHEDULE>,
    required: false,
    default: "",
  },
  hidden: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const isRefreshing = computed(() => store.state.Scanning.isLoading);
const webserviceScanningId = computed<string>(
  () => store.state.Scanning.webserviceScanningId,
);
const domainScanningId = computed<string>(
  () => store.state.Scanning.domainScanningId,
);

const dataNumberDots = computed(() => {
  const colors = ["#F7553C", "#FE9A05", "#904BD6", "#57B755"];
  const data = [
    props.severity.critical || 0,
    props.severity.high || 0,
    props.severity.medium || 0,
    props.severity.low || 0,
  ];
  return colors.map((color, index) => ({
    color,
    value: data[index],
  }));
});
const dataNumberDotsFiltered = computed(() =>
  dataNumberDots.value.filter((item) => item.value),
);

return (_ctx: any,_cache: any) => {
  return (
      __props.scanTargetType === _unref(TYPE_SCHEDULE).webservices &&
      isRefreshing.value &&
      __props.currentRefreshId === webserviceScanningId.value
    )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (
      __props.scanTargetType === _unref(TYPE_SCHEDULE).domains &&
      isRefreshing.value &&
      __props.currentRefreshId === domainScanningId.value
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(`tw-flex tw-gap-[15px] tw-h-[7px] ${__props.className}`)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.hidden ? dataNumberDotsFiltered.value : dataNumberDots.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_3, [
                (item.value || !__props.hidden)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(`tw-w-[7px] tw-h-[7px] tw-rounded-full tw-opacity-50`),
                      style: _normalizeStyle(`background-color: ${item.color}`)
                    }, null, 4))
                  : _createCommentVNode("", true),
                (item.value || !__props.hidden)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.value), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ], 2))
}
}

})